/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
import 'APP_THEME/_common/royal_slider/index.less';

import RoyalSlider from 'assets/js/modules/widgets/royalSlider';

export default class {
    constructor(selector, params) {
        $(function() {
            new RoyalSlider($(selector), params);
        });
    }
}
